<template>
    <div>
        <!-- breadcrumb -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">消息管理</el-breadcrumb-item>
            <el-breadcrumb-item>消息记录</el-breadcrumb-item>
        </el-breadcrumb>

        <!-- search -->
        <el-form :inline="true" :model="queryForm" class="user-search">
            <el-form-item label="搜索：">
                <el-date-picker size="small" v-model="createTimeRange" type="daterange" range-separator="至"
                    start-placeholder="创建时间起" end-placeholder="创建时间止" value-format="yyyy-MM-dd" style="width: 220px;"
                    clearable>
                </el-date-picker>
            </el-form-item>
            <el-form-item>
            <el-input size="small" v-model="queryForm.groupName" placeholder="微信群" clearable
                    style="width: 120px!important;"></el-input>
            </el-form-item>
            <el-form-item>
                <el-input size="small" v-model="queryForm.receivedName" placeholder="发言人" clearable
                    style="width: 120px!important;"></el-input>
            </el-form-item>
            <el-form-item>
                <el-select size="small" v-model="queryForm.textType" placeholder="消息类型" clearable style="width: 120px;">
                    <el-option label="文本" :value="1"></el-option>
                    <el-option label="图片" :value="2"></el-option>
                    <el-option label="带回复文本" :value="15"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-select size="small" v-model="queryForm.aiStatus" placeholder="AI状态" clearable style="width: 100px;">
                    <el-option label="无须AI" :value="0"></el-option>
                    <el-option label="分析中" :value="1"></el-option>
                    <el-option label="分析成功" :value="2"></el-option>
                    <el-option label="分析完毕" :value="3"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-select size="small" v-model="queryForm.brotherPushStatus" placeholder="推送状态" clearable
                    style="width: 110px;">
                    <el-option label="无须推送" :value="0"></el-option>
                    <el-option label="推送中" :value="1"></el-option>
                    <el-option label="推送成功" :value="2"></el-option>
                    <el-option label="推送失败" :value="3"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-date-picker size="small" v-model="brotherPushTimeRange" type="daterange" range-separator="至"
                    start-placeholder="推送时间起" end-placeholder="推送时间止" value-format="yyyy-MM-dd" style="width: 220px;"
                    clearable>
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="onSearch">查询</el-button>
                <el-button size="small" type="primary" icon="el-icon-refresh" @click="onReset">重置</el-button>
            </el-form-item>
        </el-form>

        <!--list-->
        <el-table size="small" :data="tableData" highlight-current-row v-loading="loading" border
            element-loading-text="loading" style="width: 100%;">
            <el-table-column prop="id" label="ID" width="60" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="145">
                <template slot-scope="scope">
                    {{ formatDateTime(scope.row.createTime) }}
                </template>
            </el-table-column>
            <el-table-column prop="groupName" label="微信群" width="180" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="receivedName" label="发言人" width="120">
            </el-table-column>
            <el-table-column prop="textType" label="消息类型" width="85">
                <template slot-scope="scope">
                    {{ getTextTypeName(scope.row.textType) }}
                </template>
            </el-table-column>
            <el-table-column label="消息内容" width="200">
                <template slot-scope="scope">
                    <el-popover v-if="scope.row.fileBase64" placement="right" trigger="click">
                        <img :src="scope.row.fileBase64" style="max-width: 500px; max-height: 500px;" />
                        <img slot="reference" :src="scope.row.fileBase64" 
                            style="width: 50px; height: 50px; object-fit: cover; cursor: pointer; border-radius: 4px;" />
                    </el-popover>
                    <span v-else class="spoken-text" :title="scope.row.spoken">{{ scope.row.spoken || '-' }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="aiStatus" label="AI状态" width="100">
                <template slot-scope="scope">
                    <el-tag :type="getAiStatusType(scope.row.aiStatus)" size="small">
                        {{ getAiStatusName(scope.row.aiStatus) }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="aiCost" label="AI成本" width="120" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span v-html="scope.row.aiCost ? scope.row.aiCost.replace(/\|/g, '<br/>') : '-'"></span>
                </template>
            </el-table-column>            
            <el-table-column prop="brotherPushStatus" label="推送状态" width="100">
                <template slot-scope="scope">
                    <el-tag :type="getBrotherPushStatusType(scope.row.brotherPushStatus)" size="small">
                        {{ getBrotherPushStatusName(scope.row.brotherPushStatus) }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="brotherPushTime" label="推送时间" width="145">
                <template slot-scope="scope">
                    {{ formatDateTime(scope.row.brotherPushTime) }}
                </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" width="180" show-overflow-tooltip>
            </el-table-column>
            <el-table-column label="操作" min-width="80">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="showDetail(scope.row)">详情</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- page -->
        <Pagination v-bind:child-msg="pageParam" @callback_getPageData="callback_getPageData"></Pagination>

        <!-- 详情弹框 -->
        <el-dialog title="消息详情" :visible.sync="detailVisible" top="5vh" width="700px">
            <el-descriptions :column="2" border size="medium">
                <el-descriptions-item label="ID">{{ detailData.id }}</el-descriptions-item>
                <el-descriptions-item label="创建时间">{{ formatDateTime(detailData.createTime) }}</el-descriptions-item>
                <el-descriptions-item label="微信群">{{ detailData.groupName }}</el-descriptions-item>
                <el-descriptions-item label="发言人">{{ detailData.receivedName }}</el-descriptions-item>
                <el-descriptions-item label="消息类型" :span="2">{{ getTextTypeName(detailData.textType) }}</el-descriptions-item>
                <el-descriptions-item label="消息内容" :span="2">
                    <el-popover v-if="detailData.fileBase64" placement="right" trigger="click">
                        <img :src="detailData.fileBase64" style="max-width: 600px; max-height: 600px;" />
                        <img slot="reference" :src="detailData.fileBase64" 
                            style="max-width: 150px; max-height: 100px; object-fit: contain; cursor: pointer; border-radius: 4px;" />
                    </el-popover>
                    <span v-else>{{ detailData.spoken || '-' }}</span>
                </el-descriptions-item>
                <el-descriptions-item label="AI状态">
                    <el-tag :type="getAiStatusType(detailData.aiStatus)" size="small">
                        {{ getAiStatusName(detailData.aiStatus) }}
                    </el-tag>
                </el-descriptions-item>
                <el-descriptions-item label="AI成本">
                    <span v-html="detailData.aiCost ? detailData.aiCost.replace(/\|/g, '<br/>') : '-'"></span>
                </el-descriptions-item>                
                <el-descriptions-item label="推送状态">
                    <el-tag :type="getBrotherPushStatusType(detailData.brotherPushStatus)" size="small">
                        {{ getBrotherPushStatusName(detailData.brotherPushStatus) }}
                    </el-tag>
                </el-descriptions-item>
                <el-descriptions-item label="推送时间">
                    {{ detailData.brotherPushTime ? formatDateTime(detailData.brotherPushTime) : '-' }}
                </el-descriptions-item>
                <el-descriptions-item label="备注" :span="2">{{ detailData.remark }}</el-descriptions-item>
            </el-descriptions>
            
            <!-- 详情Tab -->
            <el-tabs v-model="detailActiveTab" style="margin-top: 15px;">
                <el-tab-pane label="AI请求" name="aiRequest">
                    <pre class="detail-content">{{ detailData.aiRequest || '-' }}</pre>
                </el-tab-pane>
                <el-tab-pane label="AI响应" name="aiResponse">
                    <pre class="detail-content">{{ detailData.aiResponse || '-' }}</pre>
                </el-tab-pane>
                <el-tab-pane label="兄弟平台请求" name="brotherPushRequest">
                    <pre class="detail-content">{{ detailData.brotherPushRequest || '-' }}</pre>
                </el-tab-pane>
                <el-tab-pane label="兄弟平台响应" name="brotherPushResponse">
                    <pre class="detail-content">{{ detailData.brotherPushResponse || '-' }}</pre>
                </el-tab-pane>
            </el-tabs>
            <span slot="footer" class="dialog-footer">
                <el-button @click="detailVisible = false">关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { callbackRecordPage } from '../../api/callbackRecord'
import Pagination from '../../components/Pagination'
import { loadToken } from '../../utils/util'

export default {
    name: 'CallbackRecord',
    data() {
        return {
            loading: false,
            tableData: [],
            createTimeRange: null,
            brotherPushTimeRange: null,
            detailVisible: false,
            detailData: {},
            detailActiveTab: 'aiRequest',
            queryForm: {
                current: 1,
                size: 10,
                receivedName: undefined,
                groupName: undefined,
                roomType: undefined,
                textType: undefined,
                createTimeStart: undefined,
                createTimeEnd: undefined,
                aiStatus: undefined,
                brotherPushStatus: undefined,
                brotherPushTimeStart: undefined,
                brotherPushTimeEnd: undefined,
                token: loadToken()
            },
            // page param
            pageParam: {
                currentPage: 1,
                pageSize: 10,
                total: 0
            }
        }
    },
    components: {
        Pagination
    },
    created() {
        this.getPageData()
    },
    methods: {
        // 显示详情弹框
        showDetail(row) {
            this.detailData = row
            this.detailActiveTab = 'aiRequest'
            this.detailVisible = true
        },
        // 加载分页数据
        getPageData(parameter) {
            this.loading = true
            if (!parameter) {
                parameter = this.queryForm
            }
            callbackRecordPage(parameter)
                .then(res => {
                    this.loading = false
                    this.tableData = res.data.records
                    this.pageParam.currentPage = res.data.current
                    this.pageParam.pageSize = res.data.size
                    this.pageParam.total = res.data.total
                })
                .catch(err => {
                    this.loading = false
                    console.error('获取数据失败:', err)
                    this.$message({
                        type: 'error',
                        message: '获取数据失败，请检查网络连接或稍后重试'
                    })
                })
        },
        // 分页回调
        callback_getPageData(parm) {
            this.queryForm.current = parm.currentPage
            this.queryForm.size = parm.pageSize
            this.getPageData()
        },
        // 搜索
        onSearch() {
            this.queryForm.current = 1
            // 处理创建时间范围
            if (this.createTimeRange && this.createTimeRange.length === 2) {
                this.queryForm.createTimeStart = this.createTimeRange[0]
                this.queryForm.createTimeEnd = this.createTimeRange[1]
            } else {
                this.queryForm.createTimeStart = undefined
                this.queryForm.createTimeEnd = undefined
            }
            // 处理推送时间范围
            if (this.brotherPushTimeRange && this.brotherPushTimeRange.length === 2) {
                this.queryForm.brotherPushTimeStart = this.brotherPushTimeRange[0]
                this.queryForm.brotherPushTimeEnd = this.brotherPushTimeRange[1]
            } else {
                this.queryForm.brotherPushTimeStart = undefined
                this.queryForm.brotherPushTimeEnd = undefined
            }
            this.getPageData()
        },
        // 重置
        onReset() {
            this.queryForm.receivedName = undefined
            this.queryForm.groupName = undefined
            this.queryForm.roomType = undefined
            this.queryForm.textType = undefined
            this.queryForm.createTimeStart = undefined
            this.queryForm.createTimeEnd = undefined
            this.queryForm.aiStatus = undefined
            this.queryForm.brotherPushStatus = undefined
            this.queryForm.brotherPushTimeStart = undefined
            this.queryForm.brotherPushTimeEnd = undefined
            this.createTimeRange = null
            this.brotherPushTimeRange = null
        },
        // 格式化日期时间
        formatDateTime(dateTime) {
            if (!dateTime) return ''
            return dateTime.replace('T', ' ')
        },
        // 获取消息来源名称
        getRoomTypeName(roomType) {
            const typeMap = {
                1: '外部群',
                2: '外部联系人',
                3: '内部群',
                4: '内部联系人'
            }
            return typeMap[roomType] || '未知'
        },
        // 获取消息类型名称
        getTextTypeName(textType) {
            const typeMap = {
                0: '未知',
                1: '文本',
                2: '图片',
                3: '语音',
                5: '视频',
                7: '小程序',
                8: '链接',
                9: '文件',
                13: '合并记录',
                15: '带回复文本'
            }
            return typeMap[textType] || '未知'
        },
        // 获取AI状态名称
        getAiStatusName(status) {
            const statusMap = {
                0: '无须AI',
                1: '分析中',
                2: '分析成功',
                3: '分析失败'
            }
            return statusMap[status] || '未知'
        },
        // 获取AI状态样式
        getAiStatusType(status) {
            const typeMap = {
                0: 'info',
                1: 'warning',
                2: 'success',
                3: 'danger'
            }
            return typeMap[status] || 'info'
        },
        // 获取推送状态名称
        getBrotherPushStatusName(status) {
            const statusMap = {
                0: '无须推送',
                1: '推送中',
                2: '推送成功',
                3: '推送失败'
            }
            return statusMap[status] || '未知'
        },
        // 获取推送状态样式
        getBrotherPushStatusType(status) {
            const typeMap = {
                0: 'info',
                1: 'warning',
                2: 'success',
                3: 'danger'
            }
            return typeMap[status] || 'info'
        }
    }
}
</script>

<style scoped>
.user-search {
    margin-top: 20px;
}

.user-search .el-input--small {
    width: 180px !important;
}

.detail-content {
    background-color: #f5f7fa;
    padding: 12px;
    border-radius: 4px;
    white-space: pre-wrap;
    word-wrap: break-word;
    max-height: 300px;
    overflow-y: auto;
    margin: 0;
    font-size: 13px;
}

.spoken-text {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
}
</style>



// WEBPACK FOOTER //
// src/views/callbackRecord/callbackRecord.vue